export const Images = {
    logo: require('../../assets/logo.png'),
    placeholder: require('../../assets/placeholder.png')
};